import { createContext, useContext } from "react";
import * as Tone from "tone";
import { mapValue } from "../../common/utils";
import { featuresContext as features } from "../features";

const ToneContext = createContext();

export default function ToneProvider({ children }) {
  Tone.start();
  const { speed, ripples } = features;
  const bpmVal = mapValue((speed / ripples) * 100, 50, 2666, 30, 80);
  Tone.Transport.bpm.value = bpmVal;
  return <ToneContext.Provider value={Tone}>{children}</ToneContext.Provider>;
}

export const useTone = () => {
  const Tone = useContext(ToneContext);
  return Tone;
};
